var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page full flex center middle"},[_c('h2',[_vm._v("You have been unsubscribed.")]),_c('router-link',{staticClass:"button auto top-margin-30",attrs:{"to":"/"}},[_vm._v("Back to Games")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }